export default __webpack_public_path__ + "static/media/(25).b30c0583.jpg";